// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { avatarClasses } from '@mui/material/Avatar';
import { rem } from '../../tokens/conversions';
import { avatarColors } from './avatarColors';
var smallStyles = {
    width: rem(28),
    height: rem(28),
    fontWeight: 500,
    fontSize: rem(12),
    lineHeight: rem(16)
};
var mediumStyles = {
    width: rem(36),
    height: rem(36),
    fontWeight: 600,
    fontSize: rem(16),
    lineHeight: rem(20)
};
var squareStyles = {
    borderRadius: rem(8)
};
export var Avatar = function(mode) {
    var c = avatarColors(mode);
    var offlineStyles = {
        backgroundColor: c.disabled.background,
        color: c.disabled.text,
        borderColor: 'transparent',
        '&:hover': {
            borderColor: 'transparent'
        },
        '&:active': {
            borderColor: 'transparent',
            backgroundColor: c.disabled.background
        }
    };
    var override = {
        MuiAvatar: {
            styleOverrides: {
                root: {
                    backgroundColor: c.default.background,
                    border: "".concat(rem(1), " solid ").concat(c.default.border),
                    color: c.default.text,
                    fontWeight: 600,
                    fontSize: rem(16),
                    lineHeight: rem(20),
                    width: rem(44),
                    height: rem(44),
                    '&:hover': {
                        borderColor: c.hover.border
                    },
                    '&:active': {
                        borderColor: c.active.border,
                        backgroundColor: c.active.background
                    }
                }
            },
            variants: [
                {
                    props: {
                        variant: 'smallCircular'
                    },
                    style: _define_property({}, "&.".concat(avatarClasses.root), smallStyles)
                },
                {
                    props: {
                        variant: 'smallSquare'
                    },
                    style: _define_property({}, "&.".concat(avatarClasses.root), _object_spread({}, smallStyles, squareStyles))
                },
                {
                    props: {
                        variant: 'mediumCircular'
                    },
                    style: _define_property({}, "&.".concat(avatarClasses.root), mediumStyles)
                },
                {
                    props: {
                        variant: 'mediumSquare'
                    },
                    style: _define_property({}, "&.".concat(avatarClasses.root), _object_spread({}, mediumStyles, squareStyles))
                },
                {
                    props: {
                        variant: 'largeSquare'
                    },
                    style: _define_property({}, "&.".concat(avatarClasses.root), squareStyles)
                },
                {
                    props: {
                        variant: 'offlineCircular'
                    },
                    style: _define_property({}, "&.".concat(avatarClasses.root), offlineStyles)
                },
                {
                    props: {
                        variant: 'offlineLargeSquare'
                    },
                    style: _define_property({}, "&.".concat(avatarClasses.root), _object_spread({}, offlineStyles, squareStyles))
                },
                {
                    props: {
                        variant: 'offlineMediumCircular'
                    },
                    style: _define_property({}, "&.".concat(avatarClasses.root), _object_spread({}, offlineStyles, mediumStyles))
                },
                {
                    props: {
                        variant: 'offlineMediumSquare'
                    },
                    style: _define_property({}, "&.".concat(avatarClasses.root), _object_spread({}, offlineStyles, mediumStyles, squareStyles))
                },
                {
                    props: {
                        variant: 'offlineSmallCircular'
                    },
                    style: _define_property({}, "&.".concat(avatarClasses.root), _object_spread({}, offlineStyles, smallStyles))
                },
                {
                    props: {
                        variant: 'offlineSmallSquare'
                    },
                    style: _define_property({}, "&.".concat(avatarClasses.root), _object_spread({}, offlineStyles, smallStyles, squareStyles))
                }
            ]
        }
    };
    return override;
};

//# sourceMappingURL=Avatar.js.map